export default function cartExtraController() {
  const renderSubscriptionButton = async (line, index, mcItem) => {
    const productId = line.product_id;
    if (line.selling_plan || !mcItem || !isProductAvailableForSubscription(productId)) return;

    const plans = await getSellingPlansForProduct(productId);

    if (!plans || !plans.length) return; // product has no subs

    const planSelect = document.createElement('select');
    planSelect.className = 'ds-selling-plan-select';
    planSelect.dataset.lineIndex = line.id; // 1-based in Shopify
    planSelect.dataset.qty = line.quantity;
    planSelect.disabled = true;

    setTimeout(() => {
      planSelect.disabled = false;
    }, 250);

    const opt = document.createElement('option');
    opt.value = '';
    opt.textContent = window.cartStrings.subscription_one_time_option_text || 'One-time';
    planSelect.append(opt);

    const currentSellingPlanId = line?.selling_plan_allocation?.selling_plan?.id;
    const firstSellingPlanId = plans[0].id;

    for (const plan of plans) {
      const planId = plan.id;

      const opt = document.createElement('option');
      opt.value = planId;
      opt.textContent = plan.name;

      if (planId == currentSellingPlanId) {
        opt.selected = 'selected';
      }

      planSelect.append(opt);
    }

    const planSelectWrapper = document.createElement('label');
    planSelectWrapper.className = 'ds-selling-plan-select-wrapper button';
    planSelectWrapper.appendChild(planSelect);

    const confettiElement = document.createElement('span');
    confettiElement.className = 'ds-selling-plan-confetti';
    planSelectWrapper.appendChild(confettiElement);

    const mcItemProperties = mcItem.querySelector('.mu-item-properties');
    const propertiesContainer = mcItemProperties.parentElement;

    if (!propertiesContainer) {
      return;
    }
    const sellingPlanSelect = mcItem.querySelector('.ds-selling-plan-select');
    const sellingPlanUpcell = mcItem.querySelector('.ds-selling-plan-upcell');

    if (!currentSellingPlanId) {
      if (sellingPlanSelect) {
        sellingPlanSelect.parentElement.remove();
      }

      if (!sellingPlanUpcell) {
        const upcell = document.createElement('button');
        upcell.className = 'ds-selling-plan-upcell button';
        upcell.textContent = window.cartStrings.subscribeSave;
        upcell.dataset.lineIndex = line.id;
        upcell.dataset.qty = line.quantity;
        upcell.dataset.sellingPlanId = firstSellingPlanId;

        propertiesContainer.appendChild(upcell);
      }
    } else {
      if (sellingPlanUpcell) {
        sellingPlanUpcell.remove();
      }

      if (!sellingPlanSelect) {
        propertiesContainer.appendChild(planSelectWrapper);
      } else {
        sellingPlanSelect.disabled = false;
      }
    }
  };

  const renderSubscriptionOfferAndBenefits = async (line, index, mcItem) => {
    if (!mcItem) return;

    const selling_plan = line?.selling_plan_allocation?.selling_plan;
    const mcItemProperties = mcItem.querySelector('.mu-item-properties');
    const propertiesContainer = mcItemProperties.parentElement;

    if (!propertiesContainer) return;

    const existingOfferText = mcItem.querySelector('.ds-subscription-offer-text');
    const existingOfferDescription = mcItem.querySelector('.ds-subscription-offer-description');

    if (!selling_plan) {
      if (existingOfferText) existingOfferText.remove();
      if (existingOfferDescription) existingOfferDescription.remove();
      return;
    }

    const discountType = selling_plan?.price_adjustments?.[0]?.value_type;
    const discountValue = selling_plan?.price_adjustments?.[0]?.value;

    if (
      discountValue > 0 &&
      discountType === 'percentage' &&
      !existingOfferText &&
      window.cartStrings.subscription_offer_applied_text?.length > 0
    ) {
      const offerText = window.cartStrings.subscription_offer_applied_text.replace('[DISCOUNT]', `${discountValue}%`);

      const offerTextElement = document.createElement('div');
      offerTextElement.className = 'ds-subscription-offer-text';
      offerTextElement.textContent = offerText;

      propertiesContainer.appendChild(offerTextElement);
    }

    if (existingOfferDescription) {
      return;
    }

    const offerDescription = window.cartStrings.subscription_offer_description;
    const renderDescriptionAsBenefits = window.cartSettings.showSubscriptionOfferDescriptionListAsBenefits;

    const offerDescriptionElement = document.createElement('div');
    offerDescriptionElement.classList.add('ds-subscription-offer-description');
    if (renderDescriptionAsBenefits) {
      offerDescriptionElement.classList.add('ds-subscription-offer-description-as-benefits');
    }
    offerDescriptionElement.innerHTML = offerDescription;

    mcItemProperties.insertAdjacentElement('afterend', offerDescriptionElement);
  };

  const renderDiscountedPrice = (line, index, mcItem) => {
    if (!mcItem) return;

    const dsPriceWrapper = document.createElement('div');
    dsPriceWrapper.className = 'ds-price-wrapper';

    const originalPrice = Math.max(
      line.selling_plan_allocation ? line.selling_plan_allocation.compare_at_price * line.quantity : 0,
      line.original_line_price
    ); // Use the higher of the two prices: selling plan compare at price or original line price

    const finalPrice = line.final_line_price;
    const isDiscounted = originalPrice > finalPrice;

    const originalPriceText = formatMoney(originalPrice / 100);

    if (isDiscounted) {
      const finalPriceText = formatMoney(finalPrice / 100);

      dsPriceWrapper.innerHTML = `
        <span class="ds-price-original">${originalPriceText}</span>
        <span class="ds-price-final">${finalPriceText}</span>
      `;
    } else {
      dsPriceWrapper.innerHTML = `
        <span class="ds-price-regular">${originalPriceText}</span>
      `;
    }

    const mcItemPrice = mcItem.querySelector('.mu-item-price');
    const currentPriceItem = mcItem.querySelector('.ds-price-wrapper');

    if (currentPriceItem) {
      currentPriceItem.remove();
    }

    mcItemPrice.insertAdjacentHTML('afterend', dsPriceWrapper.outerHTML);
  };

  const updateCartRenderer = debounce((items) => {
    if (!items || items.length === 0) return;

    if (typeof monster_refresh !== 'function') return; // Monster not loaded yet

    const mcCartItems = document.querySelectorAll('#mu-items-container .mu-cart-item');

    items.forEach((line, index) => {
      const mcItem = mcCartItems[mcCartItems.length - 1 - index];

      renderSubscriptionButton(line, index, mcItem);
      renderDiscountedPrice(line, index, mcItem);
      renderSubscriptionOfferAndBenefits(line, index, mcItem);
    });
    updateCartGoalText();
  }, 250);

  function changeSellingPlan(mcItem, lineItemId, quantity, sellingPlanId) {
    if (mcItem) {
      mcItem.classList.add('loading');
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: lineItemId,
        quantity: quantity,
        selling_plan: sellingPlanId,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        if (typeof monster_refresh === 'function' && !window.monsterCartBroken) {
          monster_refresh();
        }
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
      })
      .finally(() => {
        mcItem.classList.remove('loading');
      });
  }

  function onSellingPlanChange(e, isSelect = false) {
    const mcItem = e.target.closest('.mu-cart-item');
    if (!mcItem) return;

    const lineItemId = e.target.dataset.lineIndex;
    const sellingPlanId = isSelect ? e.target.value : e.target.dataset.sellingPlanId;

    const quantity = parseInt(mcItem.querySelector('.mu-item-quantity div')?.textContent, 10) || 1;

    e.target.disabled = true;

    changeSellingPlan(mcItem, lineItemId, quantity, sellingPlanId);
  }

  function updateCartGoalText() {
    const goalText = document.querySelector('.mu-goal-text');
    if (goalText) {
      const goalTexts = goalText.querySelectorAll('.mu-text-center');
      if (goalTexts.length > 1) {
        goalTexts.forEach((text, index) => {
          if (index !== goalTexts.length - 1) {
            text.style.display = 'none';
          }
        });
      } else {
        // console.log(goalTexts);
        goalTexts[0].style.display = 'block';
      }
    }
  }

  document.addEventListener('click', (e) => {
    if (e.target.classList.contains('ds-selling-plan-upcell')) {
      onSellingPlanChange(e);
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.classList.contains('ds-selling-plan-select')) {
      onSellingPlanChange(e, true);
    }
  });

  document.addEventListener('cart:updated', ({ detail: { items } }) => {
    updateCartRenderer(items);
  });
}
